import { StudentInfo, StudentsPayload } from "models";
import { Client } from "./config";

export function FetchStudentInfo(student_id: string) {
	return Client.get<{ data: StudentInfo }>(`/user?userID=${student_id}`);
}

export function FetchStudents(class_id: string) {
	return Client.get<StudentsPayload>(`/data/user_dropdown?classID=${class_id}`);
}
